import { TopicflowIconType } from "@components/topicflow-icon/topicflow-icon-helpers";

// Generic fallback for any source whose `type`/`provider` we don't have a
// dedicated icon for (external providers like github/linear/jira/hubspot, or
// unknown internal types). `externalLink` exists in TopicflowIconMap.
const FALLBACK_ICON: TopicflowIconType = "externalLink";

// Map a summary source to a TopicflowIcon. Match by `source.type` first, then
// fall back to `source.provider`, then the generic fallback. Every value here
// must exist in TopicflowIconMap (see topicflow-icon-helpers.tsx).
const TYPE_ICON_MAP: Record<string, TopicflowIconType> = {
  goal: "goal",
  feedback: "feedback",
  recognition: "recognition",
  meeting: "meeting",
  action_item: "actionItem",
  document: "file04",
};

export const getSummarySourceIcon = (source: {
  type: string;
  provider: string;
}): TopicflowIconType =>
  TYPE_ICON_MAP[source.type] ?? TYPE_ICON_MAP[source.provider] ?? FALLBACK_ICON;
